import fb from '../assets/sso/fb.svg';
import insta from '../assets/sso/insta.svg';
import gmb from '../assets/sso/gmb.svg';
import linkedin from '../assets/sso/linkedin.svg';

export type NetworkKey = 'fb' | 'insta' | 'linkedin' | 'gmb';

export interface NetworkConfig {
    key: NetworkKey;
    name: string;
    logo: string;
    displayName: string;
}

export const NETWORKS: NetworkConfig[] = [
    {
        key: 'fb',
        name: 'facebook',
        logo: fb,
        displayName: 'FACEBOOK',
    },
    {
        key: 'insta',
        name: 'instagram',
        logo: insta,
        displayName: 'INSTAGRAM',
    },
    {
        key: 'linkedin',
        name: 'linkedin',
        logo: linkedin,
        displayName: 'LINKEDIN',
    },
    {
        key: 'gmb',
        name: 'googleMyBusiness',
        logo: gmb,
        displayName: 'GOOGLE MY BUSINESS',
    },
];
